import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { BasemodelService } from 'src/app/basemodel.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CounsellingDashboardService {
 
  constructor(private http:HttpClient,private baseurl:BasemodelService) { }

  searchData(searchCriteria: string) {
    
    // let payload=
    // {
    //   "admNo": (environment.apiUrl+"/ses/student/searchByAdmNo?searchCriteria,
    //   "businessType": "COLLEGE",
    //   "mobileNo": 0,
    //   "pageCount": 0,
    //   "parentName": "",
    //   "searchKey": searchTerm,
    //   "stdName": ""
    // }
    return this.http.get( this.baseurl.getcounsellingURL()+"/auth/jwt/student/counselDetailsByAdmNo?admNo="+searchCriteria);
  }
  getdata(){
   
    return this.http.get( this.baseurl.getcounsellingURL()+"/auth/jwt/student/consellingDetails")
    .pipe(
      catchError((error) => {
        if (error.status === 401) {
          console.log('Access Denied:', error.message);
          // Handle 401 status code, e.g., show "Access Denied" message in the UI
        }

        return throwError(error);
      })
    );
  }


  getstudent(){
   
    return  this.http.get( this.baseurl.getcounsellingURL()+"/auth/jwt/student/counsellingReport") 
  }
  getdashboard(data1:any){
 
    return  this.http.get( this.baseurl.getcounsellingURL()+"/auth/jwt/student/campusWiseCounsellingReport?campusId="+data1) 
  }
  generatepdf(adm:any){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+"a6a83a30-b51d-4bea-8af3-ac4a5cdae54c",
      "Accept": "application/pdf"
    }
    );
    { 
    return this.http.get( this.baseurl.getcounsellingURL()+"/ses/stdCounselling/generatePdfReport?admNo="+adm,{ headers, responseType: 'blob' })
  }
  
  }
}
